import React from 'react';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { SbkLobbyScreen } from '@/feature/lobby-sbk/screens/SbkLobby';
import { PromoHubStack } from '@/feature/promohub/PromohubStack';

import { PredictionLobbyStackParamList } from './types';

const Stack = createNativeStackNavigator<PredictionLobbyStackParamList>();

export const LobbyStack = () => {
    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            <Stack.Screen name="PredictionLobbyScreen" component={SbkLobbyScreen} />
            <Stack.Screen name="LobbyPromohub" component={PromoHubStack} />
        </Stack.Navigator>
    );
};
